import React, { useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { columnsNationalNotes } from "./columnsNationalNotes";
import CardTable from "components/CardTable/CardTable";
import { Grid } from "@material-ui/core";
import RegularButton from "components/CustomButtons/Button";
import { saveNationalNotes } from "redux/actions/inventories/inventShipmentsActions";

export const NationalNotesView = (props) => {
    const { shipmentId, onClose } = props;
    const { isLoadingComp, } = useSelector(({ search }) => search);
    const { nationalNotes, inventory, station } = useSelector(({ inventories }) => inventories);
    const { shipmentsInventory } = inventory?.details;
    const dispatch = useDispatch();

    const shipment = shipmentsInventory.find(s => s.id === shipmentId)

    const mergedNotes = useMemo(() => {
        const nn = nationalNotes || [];
        const sn = shipment?.nationalNotes || [];
        return [...nn, ...sn];
    }, [nationalNotes, shipment]);

    const onSubmit = () => {

        const form = {
            idInventory: inventory.id,
            shipments: [{
                idNotes: shipment?.nationalNotesId,
                id: shipmentId
            }]
        };
        dispatch(saveNationalNotes(form, station.id, onClose));
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <CardTable
                    blockBtn
                    columns={columnsNationalNotes(shipmentId)}
                    data={mergedNotes}
                    isLoading={isLoadingComp?.loadingInventory}
                    hasControl
                    pageSize={nationalNotes?.length + 2 || 3}
                />
            </Grid>
            {inventory?.status !== "CLOSED" ?
                <Grid item xs={12}
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: 32,
                    }}
                >
                    <RegularButton color="transparent" onClick={onClose}>
                        Cancelar
                    </RegularButton>
                    <RegularButton
                        color={"success"}
                        onClick={onSubmit}
                    >
                        Guardar
                    </RegularButton>
                </Grid>
                : null
            }
        </Grid>
    )
}